export default __webpack_public_path__ + "media/images/theme_apple/toolButton-0b123025302536e5923ad03ac6dbee36.png";